import React, { useEffect } from 'react'
import './ClientVideoHub.css'
import PortalHeader from '../clientNavbar/PortalHeader'
import { Link } from 'react-router-dom';
import { useAuth } from '../../Auth';

// Assets
import bgImage1 from '../client-dashboard-assets/hub-detec.png'
import bgImage2 from '../client-dashboard-assets/hub-dash.png'

const ClientVideoHub = () => {
    const { organization_permissions } = useAuth();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Normalize permissions
    const hasInstallationManual = organization_permissions
        ?.some(p => p.toLowerCase().includes("installation manual".toLowerCase()));

    // Determine class for height
    const dashboardItemClass = hasInstallationManual
        ? "video-hub-item"
        : "video-hub-item full-height"; // Apply 100vh if alone
    
        const wrapperClass = hasInstallationManual
    ? 'video-hub-wrapper'
    : 'video-hub-wrapper center-content';


    return (
        <div className={wrapperClass}>
            <PortalHeader />

            <Link className={dashboardItemClass} to="/fnn_portal_dash_videos/">
                <div className="dark-overlay2"></div>
                <img src={bgImage2} alt='bg-image' />
                <h1>FNN™ Dashboard Tutorial Videos</h1>
            </Link>

            {hasInstallationManual && (
                <Link className='video-hub-item' to="/fnn_portal_detec_videos">
                    <div className="dark-overlay2"></div>
                    <img src={bgImage1} alt='bg-image' />
                    <h1>HRL™ Detector Installation Videos</h1>
                </Link>
            )}
        </div>
    )
}

export default ClientVideoHub
